import Button from '@/src/common/components/marketing/buttons/Button'
import { styled } from '@/src/stitches.config'
import { useRouter } from 'next/router'
import Head from 'next/head'

const Container = styled('div', {
    margin: '5em auto',
    width: '100%',
    maxWidth: '1000px',
    textAlign: 'center',
})

const Line = styled('hr', {
    width: '50px',
    height: '2px',
    border: 'none',
    background: '$secondary',
})

const AccentText = styled('h4', {
    fontSize: '22px',
    lineHeight: '25px',
    color: '$secondary',
})

const MainText = styled('h1', {
    fontSize: '40px',
    fontWeight: '800',
    lineHeight: '50px',
    color: '$darkest',
})

const SubText = styled('p', {
    fontSize: '24px',
    lineHeight: '36px',
    color: '#4B5563',
})

export default function VerifyEmailPage() {
    const router = useRouter()

    const handleCTA = () => {
        window.close()
        router.replace('/')
    }

    return (
        <>
            <Head>
                <title>Verify Your Email Address | PerfectGift.com</title>
            </Head>
            <Container>
                <Line />

                <AccentText>VERIFICATION SUCCESSFUL</AccentText>

                <MainText>Your email has been verified!</MainText>

                <SubText>
                    Thank you for successfully verifying your email address. To
                    continue to open your gift, please click the button below.
                </SubText>

                <Button
                    label={'RETURN TO MY GIFT'}
                    showArrow
                    css={{
                        fontSize: '20px',
                        padding: '18px 36px',
                        borderRadius: '48px',
                    }}
                    onClick={() => handleCTA()}
                />
            </Container>
        </>
    )
}
